import React from 'react';
import {
    Alert,
    Button,
    Loader,
    FormGroup,
    Heading,
} from 'arag-ui-lib';
import {PREMIUM_SETTINGS_CHECKBOX_OPTIONS} from '../../helpers/variables';
import {
    ABANDONED_POLICY_STATUSES,
    DECLINED_POLICY_STATUSES,
    DOTS,
    ERROR,
    HEADING_3,
    INFO,
    MEDIUM,
    PRIMARY,
    QUATERNARY,
    REFERRED_POLICY_STATUSES,
    REJECTED_OR_DECLINED_STATUSES,
    RIGHT,
} from '../../helpers/constants';
import {FORM_GROUP_VARIANTS} from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
const ChangeApplicationStatusModal = props => {
    const {
        Store,
        newApplication,
        handleCheck,
        handleFieldChange,
        _updatePolicyStatus,
        badResponseAppPsMessage,
        handleClearStatus,
    } = props;

    const {
        premiumSettingsType,
        multipleAppPremiumSettingsFound,
        selectedStatus,
        patching,
        failedToReceivePremiumMsg,
        patchApplicationAfterPremiumFailMessage,
        selectedStatusMachineName,
    } = Store;

    const {referredReason, rejectedReason, abandonedReason, badMsg} = newApplication;
    const rejectedDeclinedReasonLabel = DECLINED_POLICY_STATUSES.includes(selectedStatusMachineName) ? CONTENT_STRINGS.DECLINED_REASON : CONTENT_STRINGS.REJECTED_REASON;

    return (
        <div>
            <Heading 
                variant={HEADING_3}
                title={<>{CONTENT_STRINGS.CHANGE_STATUS_CONFIRM_MESSAGE} <strong>{Store.selectedStatus}</strong> ? </>}
                headingTestId={'change-status-confirmation-heading'}
            />
            {
                multipleAppPremiumSettingsFound
                ?
                    <FormGroup
                        labelSize={"col-sm-12"}
                        inputSize={"col-sm-12"}
                        variant={FORM_GROUP_VARIANTS.RADIO_BUTTON_GROUP}
                        inputProps={{
                            id: 'premiumType',
                            name: 'premiumType',
                            onChange: handleCheck,
                            value: premiumSettingsType,
                            options: PREMIUM_SETTINGS_CHECKBOX_OPTIONS,
                            checked: premiumSettingsType,
                        }}
                        formGroupTestId={'change-status-confirmation-reason-form-group'}
                    />
                :
                    null
            }
            {
                REFERRED_POLICY_STATUSES.includes(selectedStatusMachineName)
                ?
                    <FormGroup
                        variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                        label={CONTENT_STRINGS.REFERRED_REASON}
                        labelSize={"col-sm-4"}
                        inputSize={"col-sm-8"}
                        inputProps={{
                            name: 'referredReason',
                            value: referredReason,
                            onChange: handleFieldChange,
                        }}
                        formGroupTestId={'change-status-confirmation-reason-form-group'}
                    />
                :
                    null
            }
            {
                REJECTED_OR_DECLINED_STATUSES.includes(selectedStatusMachineName)
                ?
                    <FormGroup
                        variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                        label={rejectedDeclinedReasonLabel}
                        labelSize={"col-sm-4"}
                        inputSize={"col-sm-8"}
                        inputProps={{
                            name: 'rejectedReason',
                            value: rejectedReason,
                            onChange: handleFieldChange,
                        }}
                        formGroupTestId={'change-status-confirmation-reason-form-group'}
                    />
                :
                    null
            }
            {
                ABANDONED_POLICY_STATUSES.includes(selectedStatusMachineName)
                ?
                    <FormGroup
                        variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                        label={`${selectedStatus} ${CONTENT_STRINGS.REASON}`}
                        labelSize={"col-sm-4"}
                        inputSize={"col-sm-8"}
                        inputProps={{
                            name: 'abandonedReason',
                            value: abandonedReason,
                            onChange: handleFieldChange,
                        }}
                        formGroupTestId={'change-status-confirmation-reason-form-group'}
                    />
                :
                    null
            }

            <div className="row">
                <div className={"col-sm-12"} style={{display: 'flex', gap: '15px'}}>
                    <Button
                        label={CONTENT_STRINGS.CONFIRM}
                        variant={PRIMARY}
                        onClick={_updatePolicyStatus}
                        arrowDirection={RIGHT}
                        disabled={patching}
                        buttonTestId={"change-status-confirmation-confirm"}
                    />
                    <Button
                        label={CONTENT_STRINGS.CANCEL}
                        variant={QUATERNARY}
                        onClick={handleClearStatus}
                        arrowDirection={RIGHT}
                        disabled={patching}
                        buttonTestId={"change-status-confirmation-cancel"}
                    />
                    {
                        patching
                        ?
                            <Loader variant={DOTS} dotSize={MEDIUM} />
                        :
                            null
                    }
                </div>
                {
                    badMsg
                    ?
                        <div className="col-sm-12">
                            <Alert variant={ERROR} label={badMsg} />
                        </div>
                    :
                        null
                }
                {
                    badResponseAppPsMessage
                    ?
                        <div className="col-sm-12">
                            <Alert variant={ERROR} label={badResponseAppPsMessage} />
                        </div>
                    :
                        null
                }
                {
                    multipleAppPremiumSettingsFound
                    ?
                        <div className="col-sm-12">
                            <Alert variant={INFO} label={CONTENT_STRINGS.MULTIPLE_PREMIUM_SETTINGS_FOUND} />
                        </div>
                    :
                        null
                }
                {
                    failedToReceivePremiumMsg && !multipleAppPremiumSettingsFound
                    ?
                        <div className="col-sm-12">
                            <Alert variant={ERROR} label={failedToReceivePremiumMsg} />
                        </div>
                    :
                        null
                }
                {
                    patchApplicationAfterPremiumFailMessage
                    ?
                        <div className="col-sm-12">
                            <Alert variant={ERROR} label={patchApplicationAfterPremiumFailMessage} />
                        </div>
                    :
                        null
                }
            </div>
        </div>
    );
};

export default ChangeApplicationStatusModal;